import styled from 'styled-components';

interface StyledLogoProps {
  size: 'small' | 'large';
}

export const StyledLogo = styled.img<StyledLogoProps>`
  ${props => props.size === 'small' && `height: 32px;`}
`;
